import { AlphaXBoxOutlineIcon } from './AlphaXBoxOutlineIcon';

/**
 * author: Contributors
 * id 98537673-0A9D-4982-A0E0-BFD69A0C1401
 * name alpha-x-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-x-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterXBoxOutlineIcon = AlphaXBoxOutlineIcon;
export default LetterXBoxOutlineIcon